import React from "react";
import { Card, Button } from "antd";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const QuestionList = ({
  questions,
  setQuestions,
  targetCount,
  onEditQuestion,
}) => {
  const questionTypeLabels = {
    tf: "True or False",
    mcq: "MCQ (Single Answer)",
    multiple_answer: "Multiple Choice (Multiple Answers)",
    fill_blank: "Fill in the Blanks",
    fill_blank_desc: "Fill in the Blanks with Description",
    matching_list: "Match the Following",
    table_q: "Table Questions",
    image: "Image-based Questions",
  };

  const handleEdit = (id) => {
    const questionToEdit = questions.find((q) => q.id === id);
    if (questionToEdit && onEditQuestion) {
      onEditQuestion(questionToEdit);
      // Optional: Scroll to top to see the form
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleDelete = (id) => {
    setQuestions(questions.filter((q) => q.id !== id));
  };

  const handleClearAll = () => {
    if (window.confirm("Are you sure you want to clear all questions?")) {
      setQuestions([]);
    }
  };

  const getProgressColor = () => {
    if (!targetCount) return "#1677ff";
    const percentage = (questions.length / parseInt(targetCount)) * 100;
    if (percentage >= 100) return "#52c41a";
    if (percentage >= 70) return "#1677ff";
    return "#faad14";
  };

  return (
    <Card
      bordered={false}
      style={{ marginTop: 16, background: "#fafafa" }}
      className="questionListCard"
    >
      {/* Progress Bar */}
      {targetCount && parseInt(targetCount) > 0 && (
        <div style={{ marginBottom: 12 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 6,
            }}
          >
            <span style={{ fontSize: "12px", color: "#666" }}>
              Progress: <strong>{questions.length}</strong> / {targetCount}{" "}
              questions
            </span>
            <span style={{ fontSize: "12px", color: "#666" }}>
              {Math.min(
                Math.round((questions.length / parseInt(targetCount)) * 100),
                100,
              )}
              %
            </span>
          </div>
          <div
            style={{
              width: "100%",
              height: "8px",
              background: "#e0e0e0",
              borderRadius: "4px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${Math.min((questions.length / parseInt(targetCount)) * 100, 100)}%`,
                height: "100%",
                background: getProgressColor(),
                transition: "all 0.3s ease",
              }}
            />
          </div>
        </div>
      )}

      <div
        className="questionsScrollContainer"
        style={{
          maxHeight: "300px",
          overflowY: "auto",
          background: "#fff",
          borderRadius: "6px",
          padding: "12px",
          border: "1px solid #e0e0e0",
        }}
      >
        <h3 style={{ margin: "0 0 12px 0" }}>
          Added Questions ({questions.length})
        </h3>

        {questions.length === 0 ? (
          <p
            style={{
              textAlign: "center",
              color: "#ff4d4f",
              margin: "24px 0",
              fontWeight: 500,
            }}
          >
            No questions yet! Start by adding a question above.
          </p>
        ) : (
          <>
            {questions.map((q) => (
              <Card
                key={q.id}
                size="small"
                style={{
                  marginBottom: 10,
                  position: "relative",
                  borderLeft: "3px solid #1677ff",
                }}
              >
                <p style={{ marginBottom: 4, paddingRight: 60 }}>
                  <strong>Q{q.id}.</strong> {q.question}
                </p>
                <p
                  style={{
                    marginBottom: 0,
                    fontSize: "12px",
                    color: "#666",
                    background: "#f0f7ff",
                    display: "inline-block",
                    padding: "2px 8px",
                    borderRadius: "3px",
                  }}
                >
                  {questionTypeLabels[q.type] || q.type}
                </p>

                <EditIcon
                  onClick={() => handleEdit(q.id)}
                  style={{
                    fontSize: "18px",
                    color: "#1677ff",
                    position: "absolute",
                    right: "36px",
                    top: "12px",
                    cursor: "pointer",
                  }}
                />
                <DeleteIcon
                  onClick={() => handleDelete(q.id)}
                  style={{
                    fontSize: "18px",
                    color: "#ff4d4f",
                    position: "absolute",
                    right: "12px",
                    top: "12px",
                    cursor: "pointer",
                  }}
                />
              </Card>
            ))}
          </>
        )}
      </div>

      {questions.length > 0 && (
        <Button
          danger
          onClick={handleClearAll}
          style={{ marginTop: 12, width: "100%" }}
        >
          Clear All Questions
        </Button>
      )}
    </Card>
  );
};

export default QuestionList;
